<template>
    <div id="container">
        <div id="content">
            <h1>Part and Half Time Students</h1>
            <a :href="'/api/report/part-and-half-time-students.xlsx'" target="_blank">Download as CSV</a><br><br>
            <table v-loading="loading">
                <tbody>
                <tr>
                    <th>Academic Year</th>
                    <th colspan="2"># students</th>
                    <th colspan="2">Total Exams</th>
                    <th colspan="2">Total Note Taking Services</th>
                    <th colspan="2">Total EText Media</th>
                    <th colspan="2">Total Contact Notes with LS</th>
                    <th colspan="2">Total Contact Notes with Assistive Tech</th>
                    <th colspan="2">Total Approved Housing Students</th>
                </tr>
                <tr>
                    <th></th>
                    <th>Part Time</th>
                    <th>Half Time</th>
                    <th>Part Time</th>
                    <th>Half Time</th>
                    <th>Part Time</th>
                    <th>Half Time</th>
                    <th>Part Time</th>
                    <th>Half Time</th>
                    <th>Part Time</th>
                    <th>Half Time</th>
                    <th>Part Time</th>
                    <th>Half Time</th>
                    <th>Part Time</th>
                    <th>Half Time</th>
                </tr>

                <template v-for="(row, index) in data">
                    <tr :key="index">
                        <td>{{ row.name }}</td>
                        <td>{{ row.part_time_students }}</td>
                        <td>{{ row.half_time_students }}</td>
                        <td>{{ row.part_time_exams }}</td>
                        <td>{{ row.half_time_exams }}</td>
                        <td>{{ row.part_time_note_taking }}</td>
                        <td>{{ row.half_time_note_taking }}</td>
                        <td>{{ row.part_time_etext }}</td>
                        <td>{{ row.half_time_etext }}</td>
                        <td>{{ row.part_time_learning }}</td>
                        <td>{{ row.half_time_learning }}</td>
                        <td>{{ row.part_time_assistive }}</td>
                        <td>{{ row.half_time_assistive }}</td>
                        <td>{{ row.part_time_housing }}</td>
                        <td>{{ row.half_time_housing }}</td>
                    </tr>
                </template>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        metaInfo() {
            return {
                title: "Part and Half Time Students"
            }
        },
        components: {},
        data() {
            return {
                data: [],
                loading: false
            }
        },
        methods: {
            load: function () {
                this.loading = true;
                this.getData();

            },
            getData: function () {
                this.loading = true;
                axios.get('/api/report/part-and-half-time-students/')
                    .then(response => {
                        if (response.data.success) {
                            this.data = response.data.rows;

                            this.loading = false;
                        }
                    })
                    .catch(error => {
                        // eslint-disable-next-line
                        console.log(error)
                    });
            }
        },
        created() {
            this.load();
        }
    }
</script>
<style scoped>
</style>
